"use client";

import {
  HydrationBoundary,
  MutationCache,
  QueryClient,
  QueryClientProvider,
} from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { ReactNode, useState } from "react";

import { showErrorToast } from "@/lib/showErrorToast";

interface ProvidersProps {
  children: ReactNode;
  dehydratedState?: unknown;
}

export const QueryProviders = ({ children, dehydratedState }: ProvidersProps) => {
  const [queryClient, setQueryClient] = useState(
    () =>
      new QueryClient({
        mutationCache: new MutationCache({
          onError: (error: any, vars, ctx, mutation) => {
            if (mutation.meta?.skipGlobalError) return; //메타 태그에 skipGlobalError가 있으면 전역 에러 처리 건너뛰기

            const apiError = error?.response?.data || error;
            showErrorToast(apiError);
          },
        }),
        defaultOptions: {
          queries: {
            retry: false,
          },
        },
      })
  );

  return (
    <QueryClientProvider client={queryClient}>
      <HydrationBoundary state={dehydratedState}>{children}</HydrationBoundary>
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  );
};

